const actions = {
  LOAD_MAILS: "LOAD_MAILS",
  LOAD_MAIL_DETAIL: "LOAD_MAIL_DETAIL",
  LOAD_MAIL_USERS: "LOAD_MAIL_USERS",
  LOAD_MAIL_JOURNAL: "LOAD_MAIL_JOURNAL",
  SET_MAIL_ITEM: "SET_MAIL_ITEM",
  SET_MAIL_ITEM_VALUE: "SET_MAIL_ITEM_VALUE",
  SET_MAIL_ERROR: "SET_MAIL_ERROR",
  SET_MAIL_IS_LOADING: "SET_MAIL_IS_LOADING",
  MAILS_ARE_LOADING: "MAILS_ARE_LOADING",
  CHANGE_MAIL_COMMENT: "CHANGE_MAIL_COMMENT",
  LOAD_RESPONSIBLE_STAFF: "LOAD_RESPONSIBLE_STAFF",
  CHANGE_RESPONSIBLE_STAFF: "CHANGE_RESPONSIBLE_STAFF",
  SUBMIT_ALL_STAFF: "SUBMIT_ALL_STAFF",
  CHANGE_STAFF_ALL: "CHANGE_STAFF_ALL",
  LOAD_USER_ANSWER: "LOAD_USER_ANSWER",
  LOAD_OPERATOR_MAILS: "LOAD_OPERATOR_MAILS",
  SEND_MAIL_USER_OPERATOR_FAIL: "SEND_MAIL_USER_OPERATOR_FAIL",
  SEND_MAIL_USER_OPERATOR_SUCCESS: "SEND_MAIL_USER_OPERATOR_SUCCESS",
  CLEAN_MAIL_STORE: "CLEAN_MAIL_STORE",
  SEND_MAIL_USER_OPERATOR_SUBMITTING: "SEND_MAIL_USER_OPERATOR_SUBMITTING",

  ATTACH_FILE: "ATTACH_FILE"
  
};

export default actions;



// WEBPACK FOOTER //
// ./src/redux/constants/admin/mailing.js